// Components/Common/ApexDonutChart.js
import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { useNavigate } from "react-router-dom";
import { Role } from '../../constants/Common';
import { Modules } from '../../constants/Module';
import { FundStage, SectorColor } from '../../constants/PriorityIcon';
import { ProjectStatuses } from '../../constants/Status';
import { useTranslation } from 'react-i18next';

const ApexPieChartProjectStages = ({ data, role, module }) => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const [projectStatusLabel, setProjectStatusLabel] = useState([])
  const [seriesData, setSeriesData] = useState([])
  const [colorData, setColorData] = useState([])
  const [filterData, setFilterData] = useState()

  useEffect(() => {
    const labels = []
    const series = []
    const color = []
    data?.length > 0 && data?.forEach((item) => {
      if (module === Modules.DELIVERABLE) {
        labels.push(t(item.currentStatus))
        series.push(item._count)
      } else if (module === 'sector') {
        labels.push(t(item.sector))
        series.push(item._count)
        color.push(SectorColor(item.sector))
      } else if (module === "isTRL") {
        labels.push(t(item.isTRL?.toUpperCase()))
        series.push(item._count)
      } else if (module === 'fundStage') {
        labels.push(t(FundStage(item.fundStage)))
        series.push(item._count)
      } else if (module === 'projectType') {
        labels.push(item.projectType)
        series.push(item._count)
      } else if (module === Modules.STAKEHOLDER) {
        labels.push(t(item.communicationState))
        series.push(item._count)
      } else if (module === 'rating') {
        labels.push(`${t(item.rating)} ${t('star')}`)
        series.push(item._count)
      } else {
        labels.push(t(item.status))
        series.push(item._count)
      }
      if (item?.color) {
        color.push(item?.color)
      }
    })
    setProjectStatusLabel(labels)
    setSeriesData(series)
    color?.length > 0 && setColorData(color)
  }, [data, module ,t])

  const options = {
    dataLabels: {
      enabled: false,
    },
    labels: projectStatusLabel,
    colors: colorData?.length > 0 ? colorData : [
      "#2b908f",
      "#f9a3a4",
      "#33b2df",
      "#546E7A",
      "#f48024",
      "#90ee7e",
      "#d4526e",
      "#13d8aa",
      "#A5978B",
      "#69d2e7"
    ],
    chart: {
      type: 'donut',
      width:'100%',
      // height: 300,
      events: {
        dataPointSelection: (event, chartContext, { dataPointIndex }) => {
          if (module === Modules.STAKEHOLDER) {
            navigate('/stakeholder-list', {
              state: {
                filterData: JSON.stringify({ role: role, filterFields: ['communicationState'], filterInputs: [projectStatusLabel[dataPointIndex]] })
              }
            })
          } else if (module === 'rating') {
            if (role && role === Role.EPMO_OFFICER) {
              let filterFields, filterInputs
              filterFields = [module, "status", 'projectUsers']
              filterInputs = [parseInt(projectStatusLabel[dataPointIndex].split(' ')?.[0]), ProjectStatuses.ONGOING, role]
              navigate('/startup-assessment-list', {
                state: {
                  filterData: JSON.stringify({ filterFields: filterFields, filterInputs: filterInputs })
                }
              })
            }
          }
          else if (module === Modules.DELIVERABLE) {
            if (role && role === Role.EPMO_OFFICER) {
              let filterFields, filterInputs
              filterFields = ["currentStatus"]
              filterInputs = [projectStatusLabel[dataPointIndex]]
              navigate('/deliverables', {
                state: {
                  filterData: JSON.stringify({ filterFields: filterFields, filterInputs: filterInputs })
                }
              })
            }
          }
          else {
            if (role && role !== Role.MEMBER) {
              let filterFields, filterInputs
              if (role) {
                filterFields = module ? [module, "status", 'projectUsers'] : ["status", "projectUsers"]
                filterInputs = module ? [module === 'fundStage' ? FundStage(projectStatusLabel[dataPointIndex]) : projectStatusLabel[dataPointIndex], ProjectStatuses.ONGOING, role] : [projectStatusLabel[dataPointIndex], role]
              } else {
                filterFields = ["status"]
                filterInputs = [projectStatusLabel[dataPointIndex]]
              }

              navigate('/all-projects', {
                state: {
                  filterData: JSON.stringify({ filterFields: filterFields, filterInputs: filterInputs })
                }
              })
            }
          }
        }
      },
    },
    noData: {
      text: t('No data found'),
      align: 'center',
      verticalAlign: 'middle',
      offsetX: 0,
      offsetY: 0,
      style: {
        color: 'black',
        fontSize: '16px',
      }
    },
    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'left',
      offsetY: 10,
      fontSize: '12px',
      itemMargin: {
        vertical: 4
      },
      markers: {
        size: 7,
        shap:'square',
        width: 10,
        height: 10
      },
      dataLabels: { enabled: false },
      containerMargin: {
        top: 10,
      },
      formatter: (val, opts) => {
        // `val` is the label, `opts.seriesIndex` is the index of the current series
        return `${val}: ${data[opts.seriesIndex]?._count}`;
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '40%',
          // labels: {
          //   show: true,
          //   name: { show: true },
          // }
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 143,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  return (
    <div>
    <Chart
      options={options}
      series={seriesData}
      type="donut"
      width="100%"
      height="220"
    />
    </div>
  )
};

export default ApexPieChartProjectStages;
